export default "__VITE_ASSET__DV$3AvKr__"